import axios from "../helpers/axios.config";
import { Endpoints } from "@/enums/endpoints.enum";
import { Permission } from "@/dtos/role";
import toastService from "./../services/toast.service";
import { User } from "@/dtos/user";

class AuthService {
  async Login(token: string): Promise<User> {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const { data } = await axios.post<any>(
        Endpoints.Login,
        {
          token: token,
          email: payload.email,
        },
        {
          skipInterceptor: true,
        } as any
      );

      const raw = data.user;

      return {
        ...raw,
        accessToken: raw.access_token,
        expiresAt: raw.expires_at ?? null,
      };
    } catch (error) {
      toastService.ShowError("toast-generic");
      throw error;
    }
  }

  /**
   * Login with email and password - Deprecated
   * @param email
   * @param password
   * @constructor
   */
  async LoginWithEmailPassword(email: string, password: string) {
    try {
      const val = await axios.post(
        Endpoints.LoginWithEmailPassword,
        {
          email,
          password,
        },
        {
          skipInterceptor: true,
        } as any
      );

      return val.data;
    } catch (error) {
      toastService.ShowError("toast-generic");
    }
  }

  async Me(accessToken?: string): Promise<any> {
    try {
      const config = accessToken
        ? ({ skipInterceptor: true, headers: { Authorization: `Bearer ${accessToken}` } } as any)
        : {};
      const response = await axios.get(Endpoints.Me, config);
      return response.data;
    } catch (error) {
      toastService.ShowError("toast-generic");
    }
  }

  async LogOut(): Promise<any> {
    try {
      const response = await axios.post(Endpoints.LogOut);
      return response.data;
    } catch (error) {
      toastService.ShowError("toast-generic");
    }
  }
  async FetchUserProfile(user: any): Promise<Record<string, any>> {
    if (!user?.uuid) return {};
    try {
      const response = await axios.get(
        Endpoints.UsersList + "/" + user.uuid,
        {
          skipInterceptor: true,
          headers: {
            "X-OFFICER-TOKEN": user.accessToken,
          },
        } as any
      );
      return response.data?.payload ?? {};
    } catch (error) {
      return {};
    }
  }

  async FetchUserPermissions(user: any) {
    if (!user) return [];
    try {
      const response = await axios.get(
        Endpoints.UsersList + "/" + user.uuid + Endpoints.PermissionsAttach,
        {
          skipInterceptor: true,
          headers: {
            "X-OFFICER-TOKEN": user.accessToken,
          },
        } as any
      );
      return response.data.permissions as Permission[];
    } catch (error) {
      toastService.ShowError("toast-generic");
    }
  }
}

export default new AuthService();
